import React, { lazy } from 'react';

const SynthProfile = lazy(() => import('./SynthProfile'));

export { SynthProfile }